import React, { useState } from 'react'
import InputComponent from '../../../Components/InputComponent/InputComponent'
import { areAllValuesNotEmpty } from '../../../Functions/Utils'
import aadhaar from "../../../assets/images/image 5.png"
import pan from "../../../assets/images/image 9.png"
import voterid from "../../../assets/images/image 11.png"
import passport from "../../../assets/images/image 12.png"
import rto from "../../../assets/images/rto.jpeg"
import bank from "../../../assets/images/Bank-Account-Verification-scaled.jpg"

function VerificationInput({ fieldsList, handleSubmit, handleChange, value, headerName,maxLength }) {
  const [count, setCount] = useState()

  const imgSelector = () => {
    //""
    switch (headerName) {
      case 'Voter ID': return (voterid)
      case 'Passport': return (passport)
      case 'Aadhaar Card': return (aadhaar)
      case 'PAN Card': return (pan)
      case 'PAN Verification V4': return (pan)
      case 'RC Verification': return (rto)
      case 'Bank Account Verification': return (bank)
    }
  }

  const classSelectore = () => {
    //""
    switch (headerName) {

      case 'Passport': return ('decument_verify_logo2 me-3')
      default: return ('decument_verify_logo')
    }
  }
  // Voter ID,PAN Card,Passport,Aadhaar Card
  return (
    <>
      <div className=''>

        {/* {fieldsList.map((itm)=>(
      <InputComponent data={itm} onChange={handleChange} value={value} handleSubmit={handleSubmit} loopCount={fieldsList.length}/>
    )) } */}
        <div className="d-flex flex-column flex-md-row align-items-start ">
          <div className='br_10'>


            <img src={imgSelector()} className={`${classSelectore()} me-2 br_10`} />

          </div>
          <div className="w-100">

            {fieldsList.map((itm, index) => {
              // setCount(count + 1); // Increment the count when an input is initially rendered
              return (
                <InputComponent data={itm} onChange={handleChange} value={value} handleSubmit={handleSubmit} loopCount={fieldsList.length} count={index + 1}
                />
              );
            })}
          </div>

        </div>
        {/* <button
         type="submit"
         className="btn px_btn btn-master px-4 rounded-pill w-100 fw_500"
         onClick={handleSubmit}
        //  disabled={""}
         >
         Submit
     </button> */}
      </div>

    </>
  )
}

export default VerificationInput
